module.exports = "/static/assets/5acea83c866fa50bf9b824e8bdee4332.png";